import type { Template } from "@/types";

export const PO_06_H3_V3: Template[] = [
{
    id: "po-06-h3v3-01",
    name: "PO 01 - H3V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h3_v3_01.png",
    size: [1136, 854],
    style: {},
        slots: [         
            { id: "1", x: 41, y: 180, width: 213, height: 159, rotation: 0, imageRotation: 0 },
            { id: "2", x: 41, y: 347, width: 213, height: 159, rotation: 0, imageRotation: 0 },
            { id: "3", x: 41, y: 514, width: 213, height: 159, rotation: 0, imageRotation: 0 },
            { id: "4", x: 262, y: 180, width: 289, height: 493, rotation: 0, imageRotation: 0 },
            { id: "5", x: 586, y: 213, width: 254, height: 429, rotation: 0, imageRotation: 0 },
            { id: "6", x: 848, y: 213, width: 253, height: 429, rotation: 0, imageRotation: 0 }
        ],
},

{
    id: "po-06-h3v3-02",
    name: "PO 02 - H3V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h3_v3_02.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 39, y: 151, width: 322, height: 553, rotation: 0, imageRotation: 0 },     
        { id: "2", x: 369, y: 151, width: 161, height: 273, rotation: 0, imageRotation: 0 },
        { id: "3", x: 369, y: 432, width: 161, height: 272, rotation: 0, imageRotation: 0 },
        { id: "4", x: 607, y: 151, width: 490, height: 367, rotation: 0, imageRotation: 0 },
        { id: "5", x: 607, y: 526, width: 241, height: 178, rotation: 0, imageRotation: 0 },
        { id: "6", x: 856, y: 526, width: 241, height: 178, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h3v3-03",
    name: "PO 03 - H3V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h3_v3_03.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 39, y: 151, width: 490, height: 367, rotation: 0, imageRotation: 0 },
        { id: "2", x: 288, y: 526, width: 241, height: 178, rotation: 0, imageRotation: 0 },
        { id: "3", x: 39, y: 526, width: 241, height: 178, rotation: 0, imageRotation: 0 },
        { id: "4", x: 606, y: 151, width: 322, height: 553, rotation: 0, imageRotation: 0 },
        { id: "5", x: 936, y: 151, width: 161, height: 273, rotation: 0, imageRotation: 0 },
        { id: "6", x: 936, y: 432, width: 161, height: 272, rotation: 0, imageRotation: 0 }     
    ],
},

{
    id: "po-06-h3v3-04",
    name: "PO 04 - H3V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h3_v3_04.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 35, y: 138, width: 512, height: 384, rotation: 0, imageRotation: 0 },     
        { id: "2", x: 35, y: 530, width: 252, height: 186, rotation: 0, imageRotation: 0 },
        { id: "3", x: 295, y: 530, width: 251, height: 186, rotation: 0, imageRotation: 0 },
        { id: "4", x: 628, y: 186, width: 279, height: 483, rotation: 0, imageRotation: 0 },
        { id: "5", x: 915, y: 186, width: 141, height: 238, rotation: 0, imageRotation: 0 },
        { id: "6", x: 915, y: 432, width: 141, height: 237, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h3v3-05",
    name: "PO 05 - H3V3",
    albumType: "Hr",
    thumbnail: "/thumbnails/PO/po-06-h3_v3_05.png",
    size: [1136, 854],
    style: {},
    slots: [      
        { id: "1", x: 48, y: 81, width: 295, height: 225, rotation: 0, imageRotation: 0 },
        { id: "2", x: 48, y: 314, width: 295, height: 225, rotation: 0, imageRotation: 0 },
        { id: "3", x: 48, y: 547, width: 295, height: 224, rotation: 0, imageRotation: 0 },
        { id: "4", x: 351, y: 81, width: 411, height: 690, rotation: 0, imageRotation: 0 },
        { id: "5", x: 885, y: 81, width: 201, height: 341, rotation: 0, imageRotation: 0 },
        { id: "6", x: 885, y: 430, width: 201, height: 341, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h3v3-06",
    name: "PO 06 - H3V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h3_v3_06.png",
    size: [1136, 854],
    style: {},
    slots: [    
        { id: "1", x: 57, y: 159, width: 363, height: 264, rotation: 0, imageRotation: 0 },
        { id: "2", x: 57, y: 431, width: 363, height: 264, rotation: 0, imageRotation: 0 },
        { id: "3", x: 428, y: 159, width: 107, height: 173, rotation: 0, imageRotation: 0 },
        { id: "4", x: 428, y: 340, width: 107, height: 173, rotation: 0, imageRotation: 0 },
        { id: "5", x: 428, y: 521, width: 107, height: 173, rotation: 0, imageRotation: 0 },
        { id: "6", x: 613, y: 247, width: 478, height: 359, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h3v3-07",
    name: "PO 07 - H3V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h3_v3_07.png",
    size: [1136, 854],
    style: {},
    slots: [      
        { id: "1", x: 57, y: 159, width: 236, height: 408, rotation: 0, imageRotation: 0 },
        { id: "2", x: 301, y: 159, width: 235, height: 408, rotation: 0, imageRotation: 0 },
        { id: "3", x: 57, y: 575, width: 155, height: 119, rotation: 0, imageRotation: 0 },
        { id: "4", x: 220, y: 575, width: 154, height: 119, rotation: 0, imageRotation: 0 },
        { id: "5", x: 382, y: 575, width: 154, height: 119, rotation: 0, imageRotation: 0 },
        { id: "6", x: 693, y: 159, width: 318, height: 535, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h3v3-08",
    name: "PO 08 - H3V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h3_v3_08.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 38, y: 192, width: 288, height: 469, rotation: 0, imageRotation: 0 },
        { id: "2", x: 334, y: 192, width: 288, height: 469, rotation: 0, imageRotation: 0 },
        { id: "3", x: 630, y: 192, width: 287, height: 469, rotation: 0, imageRotation: 0 },
        { id: "4", x: 925, y: 192, width: 174, height: 151, rotation: 0, imageRotation: 0 },
        { id: "5", x: 925, y: 351, width: 174, height: 151, rotation: 0, imageRotation: 0 },
        { id: "6", x: 925, y: 510, width: 174, height: 151, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h3v3-09",
    name: "PO 09 - H3V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h3_v3_09.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 43, y: 244, width: 105, height: 178, rotation: 0, imageRotation: 0 },
        { id: "2", x: 43, y: 430, width: 234, height: 179, rotation: 0, imageRotation: 0 },
        { id: "3", x: 156, y: 244, width: 234, height: 178, rotation: 0, imageRotation: 0 },
        { id: "4", x: 285, y: 430, width: 105, height: 179, rotation: 0, imageRotation: 0 },
        { id: "5", x: 398, y: 244, width: 479, height: 365, rotation: 0, imageRotation: 0 },
        { id: "6", x: 885, y: 244, width: 208, height: 365, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h3v3-10",
    name: "PO 10 - H3V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h3_v3_10.png",
    size: [1136, 854],
    style: {},
    slots: [       
        { id: "1", x: 0, y: 232, width: 116, height: 191, rotation: 0, imageRotation: 0 },
        { id: "2", x: 0, y: 431, width: 116, height: 191, rotation: 0, imageRotation: 0 },
        { id: "3", x: 124, y: 232, width: 513, height: 390, rotation: 0, imageRotation: 0 },
        { id: "4", x: 645, y: 232, width: 235, height: 390, rotation: 0, imageRotation: 0 },
        { id: "5", x: 888, y: 232, width: 248, height: 191, rotation: 0, imageRotation: 0 },
        { id: "6", x: 888, y: 431, width: 248, height: 191, rotation: 0, imageRotation: 0 }
    ],
}
];